export const LanguageNames = (t) => {
    return {
        fr: t('French'),
        en: t('English'),
        de: t('Deutsch'),
        it: t('Italian'),
        es: t('Spanish'),
        pl: t('Polish'),
        nl: t('Dutch'),
        pt: t('Portuguese'),
        ar: t('Arabic'),
        ro: t('Romanian'),
        ua: t('Ukrainian'),
    };
};

export const notTranslatedLanguageNames = {
    fr: 'Français',
    en: 'English',
    de: 'Deutsch',
    it: 'Italiano',
    es: 'Español',
    pl: 'Polski',
    nl: 'Nederlands',
    pt: 'Português',
    ar: 'العربية',
    ro: 'Română',
    ua: 'Українська',
};

// if t isn't provided, it will return the not translated version of the language names
export const getSupportedLanguageOptions = (i18n, t = null) => {
    const labels = t ? LanguageNames(t) : notTranslatedLanguageNames;
    return (i18n.options.supportedLngs || [])
        .filter((code) => typeof code === 'string' && code !== 'cimode')
        .map((code) => ({ value: code, label: labels[code] ?? code }));
};
